/**
 * 이용 수단(`GET /entitlements`) → `PassContent` 매퍼.
 *
 * 구매모듈의 표기 정책이 모이는 단일 지점이다.
 *
 * 이전 `GET /memberships` 기반 매퍼(`ticketToPassContent`)와 달라진 판정은 두 개다.
 *  1. 무제한을 카테고리가 아니라 서버가 주는 `isUnLimited` 로 판정한다
 *  2. 그 결과 표기용 무제한과 검증 스킵이 **한 판정으로 수렴**한다 — 기존에는 집합이 달랐다
 *     (표기: freepass·쏠북플러스 계열 / 검증 스킵: freepass·`availableCount === 999999`)
 *
 * 차감 축(`deductionMethod`)은 교체 때 사라졌다가 되돌아온 필드다. 값으로 역추론하던 동안
 * 횟수권이 금액권으로 오판돼 리스트가 통째로 사라지는 회귀가 있었다.
 */ /**
 * 차감 축. 서버가 `deductionMethod` 로 명시하면 그대로 따른다 —
 * 구 `Ticket.deductionMethod` 와 같은 값이라 이 경로가 교체 전 동작이다.
 *
 * 값을 역추론하는 것은 서버가 축을 주지 않을 때뿐이다(구독·무제한). 이때 금액으로 보려면
 * **금액 잔여만 실려 있어야** 한다. `availableAmount` 가 `null` 이 아닌 것만 보고 금액으로
 * 접으면, 횟수권에 `availableAmount: 0` 이 함께 오는 응답이 전부 "잔액 0" 으로 읽힌다.
 */ const resolveDeduction = (item)=>{
    if (item.deductionMethod) return item.deductionMethod;
    return item.availableCount === null && item.availableAmount !== null ? "amount" : "count";
};
/**
 * 무제한 판정. 서버 `isUnLimited` 가 1차 기준이다.
 *
 * 뒤 조건이 필요한 이유 — `isUnLimited` 는 `subscription` 이면 상시 false 로 오는데,
 * 커버 이용권이 무차감인 구독은 잔여를 둘 다 주지 않는다. 그 조합을 무제한으로 접지 않으면
 * `hasRemains` 가 비어 '사용완료' + disabled 로 접히고, 전부 불가면 리스트 자체가 사라진다.
 */ const resolveIsUnlimited = (item)=>item.isUnLimited || item.availableCount === null && item.availableAmount === null;
const resolveDetailText = (param)=>{
    let { isUnlimited , deduction , item  } = param;
    if (isUnlimited) return "사용범위 내 무제한";
    var _item_availableCount;
    if (deduction === "count") return "".concat(((_item_availableCount = item.availableCount) !== null && _item_availableCount !== void 0 ? _item_availableCount : 0).toLocaleString(), "회");
    var _item_availableAmount;
    return "".concat(((_item_availableAmount = item.availableAmount) !== null && _item_availableAmount !== void 0 ? _item_availableAmount : 0).toLocaleString(), "원");
};
export const entitlementToPassContent = (item)=>{
    const deduction = resolveDeduction(item);
    const isUnlimited = resolveIsUnlimited(item);
    var _item_usable;
    // productId 를 넘겨 조회하므로 판정이 수행되어 null 이 오지 않는다. 방어적으로만 false 로 접는다
    const usable = (_item_usable = item.usable) !== null && _item_usable !== void 0 ? _item_usable : false;
    const base = {
        id: item.id,
        type: item.type,
        title: item.title,
        usable,
        deduction,
        isUnlimited,
        // 무제한이면 한도 개념이 없으므로 잔여 검증도 하지 않는다
        skipLimitCheck: isUnlimited,
        availableCount: item.availableCount,
        availableAmount: item.availableAmount
    };
    // 사용범위 불일치 — 잔여와 무관하게 선택 불가. 남은 기간도 노출하지 않는다
    if (!usable) {
        return {
            ...base,
            detailText: "사용범위에 맞지 않는 자료",
            isDisabled: true
        };
    }
    const hasRemains = deduction === "count" ? item.availableCount : item.availableAmount;
    if (!isUnlimited && !hasRemains) {
        return {
            ...base,
            detailText: "사용완료",
            isDisabled: true
        };
    }
    return {
        ...base,
        detailText: resolveDetailText({
            isUnlimited,
            deduction,
            item
        }),
        remainDay: item.remainDay,
        isDisabled: false
    };
};
